import { DropdownChangeHandler } from '../../dropdownChangeHandlers'

const handleSolarPortPortrait1inP: DropdownChangeHandler = (system) => {
  if (system.integration_json?.solarPortGroundMount) {
    system.integration_json.solarPortGroundMount.arraySpacing = 4000
  }
  window.editor.signals.objectChanged.dispatch(system, 'mounting')
}

const handleSolarPortPortrait2inP: DropdownChangeHandler = (system) => {
  if (system.integration_json?.solarPortGroundMount) {
    system.integration_json.solarPortGroundMount.arraySpacing = 5000
  }
  window.editor.signals.objectChanged.dispatch(system, 'mounting')
}

export const solarPortDropdownHandlers: Record<string, Record<string, DropdownChangeHandler>> = {
  portraitConfig: {
    '1inP': handleSolarPortPortrait1inP,
    '2inP': handleSolarPortPortrait2inP,
  },
}
